import { Dialog } from './Dialog'
import ReactPlayer from 'react-player'

const baseS3Url = 'https://ik.imagekit.io/habitsgame/tr:w-350,h-350,f-mp4'

interface Props {
  videoFileName: string
  onCancel: Function
}

const GetInspiredDialog = ({ videoFileName, onCancel }: Props) => {
  return (
    <Dialog
      title={`🦸🏽 Video High Five!`}
      hasSubmitButton={false}
      closeText="Done!"
      onClose={onCancel}
    >
      <ReactPlayer
        width={'100%'}
        url={`${baseS3Url}/${videoFileName}`}
        playing={true}
        loop={true}
        controls={true}
        playsinline={true}
      />
    </Dialog>
  )
}

export default GetInspiredDialog
